import { Container, Title, Stack } from "@repo/ui/core";
import { ParkingLot } from "@components/ParkingLot";

export function ParkingLotPage() {
  return (
    <Container size="md" py="xl">
      <Stack gap="xl">
        <Title order={2}>Parking Lot</Title>
        <ParkingLot />
      </Stack>
    </Container>
  );
}
